import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { IMedicinePrescription, IPastPsychiatricHistory, IPatientAllergy, IPatientConcern, IPatientRedFlag, IPatientSurgeryAndProcedure } from "@curefit/ehr-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import * as _ from "lodash";
import * as React from "react";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import HabitEditViewContainer from "../../containers/EditView/HabitEditViewContainer";
import LMPEditViewCont from "../../containers/EditView/LMPEditViewCont";
import PersonalInformationEditViewCont from "../../containers/EditView/PersonalInformationEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import IEditedBy from "../../models/IEditedBy";
import IMedicineSuggestions from "../../models/IMedicineSuggestions";
import IPatientCondition from "../../models/IPatientCondition";
import { ITypeFormResponse } from "../../models/ITypeFormResponse";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IHabitStaticData from "../../models/staticData/IHabitStaticData";
import IinfoQues from "../../models/staticData/IinfoQues";
import IMedicineType from "../../models/staticData/IMedicineType";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import IQuestionnaire from "../../models/util/IQuestionnaire";
import {
    AppConstants,
    AppMessages,
    ConfigConstants,
    ConsultationStatusConstant,
    DoctorType,
    DosageSlots,
    subSectionsList,
    TabNames,
    toastNotificationAppearance
} from "../../utils/AppConstants";
import AppUtils, { EpochConstants } from "../../utils/AppUtils";
import removeQ from "../../utils/DataUtils";
import { Tracker } from "../../utils/Tracker";
import { EditViewDisplayMode } from "../common/EditViewCard";
import PatientPastIllnesses from "../patient/view/PatientPastIllnesses";
import CovidAssessmentRecords from "../../containers/CovidAssessmentRecords";
import CTA, { CTATheme } from "../common/CallToAction";
import { historyWidgets } from "../../utils/HistoryMedicationWidgets";
import { EHRRequestMapper } from "../../api/EHRRequestMapper";
import TherapistPastSessions from "./TherapistPastSessions";
import { historyAndIntakeSectionConfiguration } from "../../SectionConfigurations/historyAndIntakeSectionConfiguration";
import AutoSaveUtils from "../../utils/AutoSaveUtils";
import { HOME_PAGE_ROUTE, RouteUtils } from "../../routes";

/**
 * Created by abhinav on 02/02/18.
 */

export interface PatientHistoryTabProps {
    appointmentId?: number,
    editedBy: IEditedBy,
    patientId: number,
    patientAllergies: IPatientAllergy[],
    patientSurgeries: IPatientSurgeryAndProcedure[],
    patientMedication: IMedicinePrescription[],
    patientConditions: IPatientCondition[],
    staticConditions: IStaticDataValue[],
    patientConcerns: IPatientConcern[],
    patientRedFlags: IPatientRedFlag[],
    staticRedFlags: IStaticDataValue[],
    staticMedicineTypes: IMedicineType[],
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile, subSectionKey: string, appointmentId: number) => void,
    nextTab: () => void,
    pastConsultations: IAppointmentScheduleResponse[],
    staticPersonalInfo: IinfoQues,
    staticPersonalInfoPhysiotherapist: IinfoQues,
    patientPersonalProfile: PatientPersonalProfile,
    saveEditedPatientProfile: (patientPersonalProfile: PatientPersonalProfile) => void,
    updatePatientProfileData: (id: number, profile: PatientPersonalProfile) => Promise<any>,
    personalProfileId: number | string,
    fetchStaticSymptomsData: (input: string) => Promise<any>;
    patientTypeFormData: ITypeFormResponse;
    typeFormMapping: any;
    pastPsychiatricHistoryList: IPastPsychiatricHistory[],
    fetchStaticDiseasesData?: (input: string) => Promise<IDiagnosticSuggestions[]>;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
    doctorType: string;
    savePatientMedicalProfileSuccess: (patientId: number, patientMedicalProfile: any) => void,
    saveAllProfilesForPatient: (curefitUserId: number, patientId: number, isSelf: boolean, allProfiles: PatientPersonalProfile) => Promise<any>,
    isSelf: boolean,
    curefitUserId: number,
    uiConfiguration: any[],
    staticPatientHabits: IHabitStaticData,
    className: string,
    fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => Promise<any>,
    isCovidActivePack?: boolean,
    handleCompleteConsultConfirmation: () => void
}

export interface PatientHistoryTabState {
    error: string,
    errorDetails?: string,
    isSaving?: boolean,
    widgets: any,
    suggestedCondition: any,
    updatedConditions: any,
    updatedHistoryList: any,
    updatedSelections: any,
    selectionTargetField: string,
    listKey: string
}

const allowedHabits: string[] = ["smoking", "alcohol"];

class PatientHistoryTab extends React.Component<PatientHistoryTabProps, PatientHistoryTabState> {
    private personalInfoRef: PersonalInformationEditViewCont;
    private lmpRef: LMPEditViewCont;
    private habitsRef: HabitEditViewContainer;
    private isPhysiotherapist: boolean;
    private isMindTherapist: boolean;
    suggestionsList: any;
    historySuggestionsList: any;

    constructor(props: PatientHistoryTabProps) {
        super(props);
        this.isPhysiotherapist = this.props.doctorType === DoctorType.PHYSIOTHERAPIST;
        this.isMindTherapist = this.props.doctorType === DoctorType.MIND_THERAPIST
        this.state = {
            error: null,
            errorDetails: null,
            isSaving: false,
            widgets: this.isMindTherapist ? [...historyAndIntakeSectionConfiguration] : AppUtils.getTabWidget(this.props.uiConfiguration, TabNames.HISTORY),
            suggestedCondition: {},
            updatedConditions: [],
            updatedHistoryList: [],
            updatedSelections: [],
            selectionTargetField: "",
            listKey: "suggestionsList"
        };

        this.setSuggestionsList();

    }

    componentDidMount() {
        document.getElementsByClassName("ongoing-consultation-main-cont")[0].scrollTop = 0;
        Tracker.pageOpened("History");
    }

    componentWillUnmount() {
        this.saveEditedHistory();
        Tracker.pageClosed("History");
    }

    setSuggestionsList = () => {
        let tabWidgets = this.state.widgets;
        let clonedTabWidgets = AppUtils.getDeepCopiedObject(tabWidgets);
        clonedTabWidgets.map((uiConfigData: any) => {
            if (subSectionsList.includes(uiConfigData.subSectionKey)) {
                uiConfigData.data.forEach((tabData: any) => {
                    if (tabData.key === "suggestionsList") {
                        this.suggestionsList = tabData.answerList[0].filteredStaticConditions;
                    } else if (tabData.key === "historySuggestionsList") {
                        this.historySuggestionsList = tabData.answerList[0].filteredStaticConditions
                    }
                });
            }

        })
    }

    getPatientHistoryObject = () => {
        let tabWidgets = [...this.state.widgets]
        let historyObject: any = {};
        historyObject[ConfigConstants.NEWCONFIGDATA] = {};
        tabWidgets.map((widgetData: { subSectionKey: "personalInfoRef" | "habitsRef" | "lmpRef" }) => {
            const ref = this[widgetData.subSectionKey];
            let data = ref.getSaveObject();
            if (widgetData.subSectionKey === "currentMedication") {
                data = EHRRequestMapper.getEHRSaveHistoryCurrentMedicationFromConfigBasedMedication(data);
            }
            historyObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = data;
            this.getFormattedObject(widgetData, historyObject);
        })
        return historyObject;
    }

    getFormattedObject = (widgetData: any, historyObject: any) => {
        let relationship = AppConstants.PatientRelationshipConstant.SELF.internalValue;
        let historyData: any = historyObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey];
        let keyName = Object.keys(historyData);
        historyData[keyName[0]] = removeQ(historyData[keyName[0]]);
        if (historyData.conditionsList && Array.isArray(historyData.conditionsList)) {   //adding relationship as SELF for Past Conditions
            historyData.conditionsList.map((data: any) => {

                data.items && Array.isArray(data.items) && data.items.length > 0 ? data.items[0].relationship = relationship : "";
            })
        }

        let delconditionsList: any = historyObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey];
        delete delconditionsList.target;
        if (!subSectionsList.includes(widgetData.subSectionKey)) {  //deletes conditionsList key from saving object except for PastConditions & Familyhistory
            try {
                if (delconditionsList.hasOwnProperty('conditionsList')) delete delconditionsList.conditionsList;
            }
            catch (e) {
                console.log('Error in removing conditions list ');
                console.error(e);
            }
        }
    }

    savePatientHistory = () => {
        let patientMedicalProfile = this.getPatientHistoryObject();
        const habits = this.habitsRef && this.habitsRef.getSaveObj();
        let dailyRoutine = _.get(this.props.patientPersonalProfile, "dailyRoutine", null);
        this.saveEditedHistory();
        if (this.validateHistory()) {
            this.setState({ isSaving: true, error: null });

            const personalInformation = this.personalInfoRef && { ...this.personalInfoRef.getSaveObject() };
            if (!this.isPhysiotherapist && this.lmpRef && personalInformation) {
                personalInformation.lastMenstrualPeriod = this.lmpRef.getSaveObject();
            } else {
                if (personalInformation && personalInformation.depressedFrequency) {
                    dailyRoutine.depressedFrequency = personalInformation.depressedFrequency;
                    delete personalInformation.depressedFrequency
                }
            }
            let patientPersonalProfile = { ...this.props.patientPersonalProfile, habits, personalInformation, dailyRoutine };

            Promise.all(
                [this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType),
                this.props.saveAllProfilesForPatient(this.props.curefitUserId, this.props.patientId, this.props.isSelf, patientPersonalProfile as PatientPersonalProfile)]
            ).then(() => {
                this.props.savePatientMedicalProfileSuccess(this.props.patientId, patientMedicalProfile);
                this.props.nextTab();
            }).catch(err => {
                this.setState({
                    error: AppMessages.MEDICAL_HISTORY_SAVE_ERROR,
                    errorDetails: err.message,
                    isSaving: false
                })
            });
        }
    }

    saveEditedHistory = () => {
        let patientMedicalProfile: IEHRSavePatientMedicalProfile = { ...this.props.currentMedicalProfile };
        let tabWidgets = [...this.state.widgets]
        tabWidgets.map((widgetData: any) => {
            if (patientMedicalProfile[ConfigConstants.NEWCONFIGDATA])
                patientMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientHistoryTab)[widgetData.subSectionKey].getSaveObject();
            this.props.saveEditedMedicalProfile(patientMedicalProfile, widgetData.subSectionKey, this.props.appointmentId);

        })
        const personalInformation = this.personalInfoRef && { ...this.personalInfoRef.getSaveObject() };
        if (!this.isPhysiotherapist && this.lmpRef && personalInformation) {
            personalInformation.lastMenstrualPeriod = this.lmpRef.getSaveObject();
        }
        let patientPersonalProfile: any = { ...this.props.patientPersonalProfile, habits: this.habitsRef && this.habitsRef.getSaveObj(), personalInformation };
        this.props.saveEditedPatientProfile(patientPersonalProfile)
    };

    generateScrollItems = () => {
        return [
            { name: "Concerns", component: "concern-section" },
            { name: "Past Conditions", component: "past-conditions-section" },
            { name: "Surgeries", component: "surgery-section" },
            { name: "Current Medication", component: "current-medication-section" },
            { name: "Family Conditions", component: "family-conditions-section" }
        ]
    }

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null,

        })
    }

    validateHistory = (): boolean => {
        let status = true;
        let painHistory: any = {};
        let tabWidgets = [...this.state.widgets]
        tabWidgets.map((widgetData) => {
            painHistory[widgetData.subSectionKey] = (this as any | PatientHistoryTab)[widgetData.subSectionKey].isFormDirty();
        })
        let isDirty = Object.values(painHistory).findIndex(obj => obj === true) > -1;
        if (isDirty) {
            tabWidgets.map((widgetData, index) => {
                if (painHistory[widgetData.subSectionKey]) {
                    this.invalidItemError(widgetData.subSectionTitle);
                }
            })
            status = false;
        }
        return status;
    };

    invalidItemError = (section: string) => {
        this.setState({
            error: AppMessages.MEDICAL_HISTORY_VALIDATION_ERROR,
            errorDetails: `Error in ${section}. Please Review the form and proceed.`
        })
    };

    _getAllowedHabitsObject = (habits: IQuestionnaire[]) => {
        return {
            consumptionFrequency: {
                questionnaire: habits
            }
        }
    };

    handleProceedToNextTab = () => {
        this.props.nextTab();
    }

    handleCompleteNow = () => {
        this.saveEditedHistory()
        this.props.handleCompleteConsultConfirmation()
    }

    saveDataInDraftAndExit = () => {
        clearTimeout(this.therapyDataSaveInterval);
        AutoSaveUtils.savePrescription(this.props.appointmentId, this.getDraftSavingData());
        this.props.updateAppointmentStatus(this.props.bookingId, this.props.appointmentId, ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT).then((response: any) => {
            if (!response.data.errorObject) {
                RouteUtils.navigateToHrefUrl("", HOME_PAGE_ROUTE);
            }
        }).catch((errorObject: any) => {
            let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL;
            if (!_.isEmpty(errorObject.data)) {
                errorMsg += ": " + errorObject.data.message;
                console.log(null, errorObject.data.message, errorObject.message);
            }
            AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error)
        })
    }

    render() {
        const { patientPersonalProfile, staticPatientHabits } = this.props;
        let showIllnesses = !_.isEmpty(this.props.pastConsultations);
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.MEDICAL_HISTORY_SAVE_ERROR;
        let errorDetails = !_.isNull(this.state.errorDetails) ? this.state.errorDetails : "";
        let questionnaire = !_.isEmpty(this.props.patientTypeFormData) && !_.isEmpty(this.props.patientTypeFormData.userForm) &&
            !_.isEmpty(this.props.patientTypeFormData.userForm.questionResponseDetails) ? this.props.patientTypeFormData.userForm.questionResponseDetails : [];
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        let personalInformation = !_.isEmpty(this.props.patientPersonalProfile) && !_.isEmpty(this.props.patientPersonalProfile.personalInformation) ? this.props.patientPersonalProfile.personalInformation : {};
        let dailyRoutine = !_.isEmpty(this.props.patientPersonalProfile) && !_.isEmpty(this.props.patientPersonalProfile.dailyRoutine) ? this.props.patientPersonalProfile.dailyRoutine : {};
        const lastMenstrualPeriodData = !_.isEmpty(this.props.patientPersonalProfile) && !_.isEmpty(this.props.patientPersonalProfile.personalInformation) && !_.isEmpty(this.props.patientPersonalProfile.personalInformation.lastMenstrualPeriod) ? this.props.patientPersonalProfile.personalInformation.lastMenstrualPeriod : {};
        const consumptionFrequency = patientPersonalProfile && patientPersonalProfile.habits && patientPersonalProfile.habits.genericHabits ? patientPersonalProfile.habits.genericHabits : null;
        const staticConsumptionFreq = !_.isEmpty(staticPatientHabits) && !_.isEmpty(staticPatientHabits.consumptionFrequency) && !_.isEmpty(staticPatientHabits.consumptionFrequency.questionnaire) ? staticPatientHabits.consumptionFrequency.questionnaire.filter(habit => allowedHabits.indexOf(habit.key) > -1) : null;
        const foodDislikes = patientPersonalProfile && patientPersonalProfile.foodDislikes ? patientPersonalProfile.foodDislikes : null;
        const meditationPreference = patientPersonalProfile && patientPersonalProfile.habits && patientPersonalProfile.habits.fitnessHabit && patientPersonalProfile.habits.fitnessHabit.meditationPreference ?
            patientPersonalProfile.habits.fitnessHabit.meditationPreference : null;
        let workoutPreference = patientPersonalProfile && patientPersonalProfile.habits && patientPersonalProfile.habits.fitnessHabit && patientPersonalProfile.habits.fitnessHabit.workoutPreference ?
            patientPersonalProfile.habits.fitnessHabit.workoutPreference : null;
        // let tabWidgets = AppUtils.getTabWidget(this.state.widgets, TabNames.HISTORY);
        let tabWidgets = this.state.widgets
        if (this.isPhysiotherapist && dailyRoutine.depressedFrequency) {
            personalInformation.depressedFrequency = dailyRoutine.depressedFrequency;
        }
        let textAreaClassName = "textbox-input";

        return (
            <div className={`patient-history-tab-container ${AppUtils.renderConfidentialData() ? '' : 'hide-confidential-data'}`}>
                {
                    !_.isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}
                        reportError={true} rollbarPayload={{ message: errorMessage, errorDetails: errorDetails, request: this.getPatientHistoryObject() }} />
                }
                {/*<ScrollToContainer componentToScroll={"ongoing-consultation-main-cont"} scrollItems={this.generateScrollItems()}/>*/}
                {this.props.isCovidActivePack && (
                    <CovidAssessmentRecords patientId={this.props.patientId} curefitUserId={this.props.curefitUserId} />
                )}
                {tabWidgets.map((widgetData: any) => {
                    //  let tabData = this.props.currentMedicalProfile && this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA] &&
                    //  this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] ? this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] : {};
                    let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, false, widgetData.subSectionKey);
                    const isNew = widgetData.subSectionKey === "currentMedication";
                    return <div data-section={widgetData.subSectionKey} key={widgetData.subSectionKey} className="patient-info-subsection concern-section">
                        <GenericEditViewCont ref={(historyDOM) => { (this as any | PatientHistoryTab)[widgetData.subSectionKey] = historyDOM }}
                            widgetData={widgetData}
                            displayMode={EditViewDisplayMode.EDIT}
                            tabData={tabData}
                            className={textAreaClassName}
                            isNew={isNew} />
                    </div>
                })}
                {
                    showIllnesses && !this.isMindTherapist &&
                    <div data-section={"pastSessions"} className="patient-info-subsection past-illnesses-section">
                        <PatientPastIllnesses pastConsultations={this.props.pastConsultations} fetchPastConsultationData={this.props.fetchPastConsultationData} staticMedicineTypes={this.props.staticMedicineTypes} />
                    </div>
                }

                {!this.isMindTherapist && <div data-section={"personalInformation"} className="patient-info-subsection personal-information-section">
                    <PersonalInformationEditViewCont personalInformation={personalInformation} staticPersonalInfo={this.isPhysiotherapist ? this.props.staticPersonalInfoPhysiotherapist : this.props.staticPersonalInfo}
                        displayMode={EditViewDisplayMode.EDIT} ref={(personalInfoRef) => this.personalInfoRef = personalInfoRef}
                        questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>}

                {/*{!this.isPhysiotherapist && !this.isMindTherapist && <div className="patient-info-subsection family-conditions-section">*/}
                    {/*<LMPEditViewCont*/}
                        {/*displayMode={EditViewDisplayMode.EDIT}*/}
                        {/*lmpInfo={lastMenstrualPeriodData}*/}
                        {/*ref={lmpRef => this.lmpRef = lmpRef}*/}
                    {/*/>*/}
                {/*</div>}*/}

                {!this.isMindTherapist && <div data-section={"patientHabits"} className="patient-info-subsection habit-section">
                    <HabitEditViewContainer
                        displayMode={EditViewDisplayMode.EDIT}
                        staticPatientHabits={this._getAllowedHabitsObject(staticConsumptionFreq)}
                        consumptionFrequency={consumptionFrequency}
                        showHabitsOnly={true}
                        meditationPreference={meditationPreference}
                        workoutPreference={workoutPreference}
                        foodDislikes={foodDislikes}
                        ref={(habitsRef) => this.habitsRef = habitsRef}
                    />
                </div>}
                {this.isMindTherapist && <div data-section={"pastSessions"} className="patient-info-subsection past-illnesses-section">
                    <TherapistPastSessions pastConsultations={this.props.pastConsultations} fetchPastConsultationData={this.props.fetchPastConsultationData} />
                </div>}

                {!this.isMindTherapist && <div className={"save-button collapsible-card"}>
                    <CTA innerText={saveButtonValue} theme={CTATheme.PRIMARY} onClick={this.savePatientHistory} customStyle={{ display: "inline" }} />
                </div>}
                {this.isMindTherapist && <div className={"save-button collapsible-card"}>
                    <CTA innerText={"Complete Now"} theme={CTATheme.PRIMARY} onClick={this.handleCompleteNow} customStyle={{ display: "inline" }} />
                    <CTA innerText={"Proceed to Session Notes"} theme={CTATheme.PRIMARY} onClick={this.handleProceedToNextTab} customStyle={{ display: "inline" }} />
                </div>}
            </div>
        );
    }
}

export default PatientHistoryTab